module.exports = "/_next/static/images/MakeItAContinuousConversation@2x-7464bd5d88b34e53c3e932f77d732e99.webp";